import { Expose, plainToInstance,Transform, Type } from 'class-transformer';

import { OrderItemModel } from './OrderItemModel';

import { type Order, type OrderDetail,StatusEnum } from '@/shared/api';

const ToDate = () => Transform(({ value }) => (value ? new Date(value) : null));

export class OrderModel {
  @Expose()
  id: number;

  @Expose({ name: 'created_at' }) @ToDate()
  createdAt: Date | null;

  @Expose({ name: 'updated_at' }) @ToDate()
  updatedAt: Date | null;

  @Expose({ name: 'is_active' })
  isActive?: boolean;

  @Expose({ name: 'session_token' })
  sessionToken: string;

  @Expose()
  status?: StatusEnum;

  @Expose({ name: 'short_code' })
  shortCode?: string;

  @Expose({ name: 'payment_attempts' })
  paymentAttempts?: number;

  @Expose()
  total: number;

  @Expose({ name: 'external_id' })
  externalId?: string;

  @Expose()
  comment?: string;

  @Expose()
  customer?: number;

  @Expose()
  restaurant?: number;

  @Expose()
  @Type(() => OrderItemModel)
  items?: OrderItemModel[];

  get itemsCount(): number {
    return this.items?.reduce((acc, i) => acc + (i.quantity ?? 0), 0) ?? 0;
  }

  get isPaid(): boolean {
    return this.status === StatusEnum.PAID;
  }

  get isFinished(): boolean {
    return this.status === StatusEnum.FINISHED;
  }
}

export const plainToOrderDetail = (plain: OrderDetail): OrderModel =>
  plainToInstance(OrderModel, plain, { excludeExtraneousValues: true });

export const plainToOrder = (plain: Order): OrderModel =>
  plainToInstance(OrderModel, plain, { excludeExtraneousValues: true });

export type { StatusEnum };